import {
  Directive,
  AfterViewInit,
  ElementRef,
  inject,
  Output,
  EventEmitter,
  HostListener,
} from '@angular/core';

@Directive({
  standalone: true,
  selector: '[clickOutside]',
})
export class ClickOutsideDirective implements AfterViewInit {
  private elementRef = inject(ElementRef);

  @Output() clickOutside = new EventEmitter();
  isOpen: boolean;

  constructor() {
    this.isOpen = false;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.isOpen = true;
    }, 10);
  }

  @HostListener('window:mousedown', ['$event.target']) onWindowClick(target: EventTarget | null) {
    if (!this.isOpen || !(target instanceof Node)) {
      return;
    }

    if (this.elementRef.nativeElement.contains(target)) {
      return;
    }

    if (target instanceof Element && target.closest('.ng-dropdown-panel')) {
      return;
    }

    this.clickOutside.emit(null);
  }
}
